import { defineMessages } from "react-intl";

export const scope = "components.DashboardPage";

export const messages = defineMessages({
  welcome: {
    id: `${scope}.welcome`,
    defaultMessage: "Cartera de clientes",
  },
  cvuLink: {
    id: `${scope}.cvuLink`,
    defaultMessage: "Depositar en cuenta",
  },
  lastMovements: {
    id: `${scope}.lastMovements`,
    defaultMessage: "Últimos movimientos",
  },
});
